export default "__VITE_ASSET__9db4dd7b__"